import * as actionTypes from '../constants/actionTypes';

export function setAddress(address) {
  return { type: actionTypes.ADDRESS_CHANGED, address };
}

export function cleanAddress() {
  return { type: actionTypes.ADDRESS_CLEAN };
}



// WEBPACK FOOTER //
// ./src/actions/addressActions.js